<script lang="ts">
  import { showAlert } from "stores";
  import { pop } from "svelte-spa-router";
  import { serverlessRoutes, postWithJwt, errorTracker, translate } from "lib";
  import { ButtonComponent, Svg, TextareaField } from "ui";
  import { Capacitor } from "@capacitor/core";

  let description: string = "";

  const submit = async () => {
    const url = serverlessRoutes.BUG_SUGGESTION;
    const bugSuggestion = {
      data: description,
      info: "[]",
      reportType: 0,
      title: "V2",
    };
    try {
      const res = await postWithJwt(url, { bugSuggestion });
      $showAlert.message = `${translate("SUCCESSFULLY_CREATED")} ${translate(
        "BUG_SUGGESTION"
      ).toLowerCase()}`;
    } catch (err) {
      errorTracker.captureError(err as Error | string, "error", {
        context: "settings",
        action: "submit_bug_suggestion",
        description: description?.substring(0, 100) // First 100 chars for context
      });
    }
    pop();
  };
</script>

<svelte:head>
  <style>
    body {
      overflow: hidden;
    }
  </style>
</svelte:head>

<div class="p-4 flex flex-col gap-4 {Capacitor.getPlatform() === 'android' ? 'mt-16' : Capacitor.getPlatform() === 'ios' ? 'mt-20' : ''}">

  <div class="relative pb-4">
    <div class="absolute">
      <Svg name="left-arrow-button" size={24} on:click={pop}/>
    </div>
    <div class="text-center font-semibold">
      {translate("REPORT_BUG_SUGGESTION")}
    </div>
  </div>

  <div class="flex flex-col gap-4">
    <TextareaField
      label="Opis"
      placeholder={translate("BUG_SUGGESTION_EXAMPLE")}
      error=""
      bind:value={description}
    />
    <div class="flex justify-center">
      <ButtonComponent on:click={submit}>
        {translate("SUBMIT")}
      </ButtonComponent>
    </div>
  </div>
</div>
